export default {"src":"/_next/static/media/ser.f0b0b73f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};